import { createAsyncAction } from 'typesafe-actions'
import { IAssets } from '@sparling/financial-common'

export const {
  request: getAllInstrumentsRequest,
  success: getAllInstrumentsSuccess,
  failure: getAllInstrumentsFailure,
} = createAsyncAction('GET_ALL_INSTRUMENTS_REQUEST', 'GET_ALL_INSTRUMENTS_SUCCESS', 'GET_ALL_INSTRUMENTS_FAILURE')<
  void,
  IAssets[],
  Error
>()
